// extracted by mini-css-extract-plugin
module.exports = {"comment-section":"CommentSection_comment-section__2n4vP","comment":"CommentSection_comment__8LxbQ"};